import { useCommanderSelector } from '@mews-commander/utils';
import { getCustomerOrCompanyFullName } from '@mews-commander/legacy-entities/src/ducks/customers';
import { TextKey } from '@mews-commander/enums';
import { useLocalizeText } from '@mews/framework';

export const useCreateDefaultBillNameValuesFromAccountId = (accountId: string) => {
    const accountName = useCommanderSelector((state) => getCustomerOrCompanyFullName(state, { id: accountId })) ?? '';

    const lt = useLocalizeText();

    return {
        accountName,
        defaultValues: {
            name: lt({
                textKey: TextKey.OpenBillDefaultName,
                substitutes: { name: accountName },
            }),
        },
    };
};
